import React from "react";
import { MarketingUIProvider } from "./MarketingUIContext";
import MarketingCard from "./Marketing";
import { BannerDeleteDialog } from "./marketing-dialog/BannerDeleteDialog";
import { Route } from "react-router-dom";

export function MarketingPage({ history }) {
  
  const marketingUIEvents = {
    newBannerButtonClick: () => {
      history.push(`/app/marketing/new`);
    },
    openEditBannerPage: (id) => {
      history.push(`/app/marketing/${id}/edit`);
    },
    openDeleteBannerDialog: (id) => {
      history.push(`/marketing/${id}/delete`);
    },
  };

  return (
    <MarketingUIProvider marketingUIEvents={marketingUIEvents}>
      <Route exact path={`/marketing/:id/delete`}>
        {({ history, match }) => {
          return (
            <BannerDeleteDialog
              show={match != null}
              id={match && match.params.id}
              onHide={() => {
                history.push(`/marketing`);
              }}
            />
          );
        }}
      </Route>
      <MarketingCard />
    </MarketingUIProvider>
  );
}
